
export module Template {

	export function setActiveSidebar() {
		$('.sidebar-nav').find('a.nav-link').each(function () {

			$(this).removeClass('active');

			var cUrl = String(window.location.pathname).split('?')[0];

			if (cUrl.substr(cUrl.length - 1) == '#') {
				cUrl = cUrl.slice(0, -1);
			}

			var aHref = $(this).attr("href") || "SomeThingThatDoesNotExists";
			if (aHref == "/")
				aHref = "SomeThingThatDoesNotExists";

			var href2 = $(this).attr("href2") || "SomeThingThatDoesNotExists";
			if (href2 == "/")
				href2 = "SomeThingThatDoesNotExists";


			if ((cUrl.toLowerCase().indexOf(aHref.toLowerCase()) >= 0) || (cUrl.toLowerCase().indexOf(href2.toLowerCase()) >= 0)) {
				$(this).addClass('active');

				$(this).parents('ul').add(this).each(function () {
					$(this).parent().addClass('open');
				});
			}
		});
	}

	export function init() {

		var config = <any> new Object();

		config.navigation = $('nav > ul.nav');

		config.panelIconOpened = 'fa fa-angle-up';
		config.panelIconClosed = 'fa fa-angle-down';

		//Default colours
		config.brandPrimary = '#20a8d8';
		config.brandSuccess = '#4dbd74';
		config.brandInfo = '#63c2de';
		config.brandWarning = '#f8cb00';
		config.brandDanger = '#f86c6b';

		config.grayDark = '#2a2c36';
		config.gray = '#55595c';
		config.grayLight = '#818a91';
		config.grayLighter = '#d1d4d7';
		config.grayLightest = '#f8f9fa';


		setActiveSidebar();
		//config.navigation.find('a').each(function () {

		//	var cUrl = String(window.location.pathname).split('?')[0];

		//	if (cUrl.substr(cUrl.length - 1) == '#') {
		//		cUrl = cUrl.slice(0, -1);
		//	}

		//	var aHref = $(this).attr("href") || "SomeThingThatDoesNotExists";
		//	if (aHref == "/")
		//		aHref = "SomeThingThatDoesNotExists";
		//	if (cUrl.toLowerCase().indexOf(aHref.toLowerCase()) >= 0) {
		//		$(this).addClass('active');

		//		$(this).parents('ul').add(this).each(function () {
		//			$(this).parent().addClass('open');
		//		});
		//	}
		//});

		// Dropdown Menu
		config.navigation.on('click', 'a', function (e) {

			if (config.ajaxLoad) {
				e.preventDefault();
			}

			if ($(this).hasClass('nav-dropdown-toggle')) {
				$(this).parent().toggleClass('open');
				resizeBroadcast();
			}

		});

		function resizeBroadcast() {

			var timesRun = 0;
			var interval = setInterval(function () {
				timesRun += 1;
				if (timesRun === 5) {
					clearInterval(interval);
				}
				window.dispatchEvent(new Event('resize'));
			}, 62.5);
		}

		/* ---------- Main Menu Open/Close, Min/Full ---------- */
		$('.navbar-toggler').click(function () {

			if ($(this).hasClass('sidebar-toggler')) {
				$("#divSidebarWitewash").removeClass("hidden").addClass("opacity-8").height($("body").height());
				$('body').toggleClass('sidebar-hidden');
				resizeBroadcast();
			}

			if ($(this).hasClass('aside-menu-toggler')) {
				$('body').toggleClass('aside-menu-hidden');
				resizeBroadcast();
			}

			if ($(this).hasClass('mobile-sidebar-toggler')) {
				$('body').toggleClass('sidebar-mobile-show').toggleClass('sidebar-hidden');
				$('body').addClass("mobile-sidebar");
				resizeBroadcast();
			}

		});

		//$('.sidebar-close').click(function () {
		//	$('body').toggleClass('sidebar-opened').parent().toggleClass('sidebar-opened');
		//});

		/* ---------- Disable moving to top ---------- */
		$('a[href="#"][data-top!=true]').click(function (e) {
		});

		$(document).on('click', '.card-actions a', function (e) {
			e.preventDefault();

			if ($(this).hasClass('btn-close')) {
				$(this).parent().parent().parent().fadeOut();
			} else if ($(this).hasClass('btn-minimize')) {
				var $target = $(this).parent().parent().next('.card-block');
				if (!$(this).hasClass('collapsed')) {
					$('i', $(this)).removeClass(config.panelIconOpened).addClass(config.panelIconClosed);
				} else {
					$('i', $(this)).removeClass(config.panelIconClosed).addClass(config.panelIconOpened);
				}

			} else if ($(this).hasClass('btn-setting')) {
				$('#myModal').modal('show');
			}

		});

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		function init(url) {

			/* ---------- Tooltip ---------- */
			$('[rel="tooltip"],[data-rel="tooltip"]').tooltip({ "placement": "bottom", delay: { show: 400, hide: 200 } });

			/* ---------- Popover ---------- */
			$('[rel="popover"],[data-rel="popover"],[data-toggle="popover"]').popover();

		}
	}
}
